import Cashia from '../../../../assets/cashia-checkout.svg';
import Pci from '../../../../assets/pci.svg';
const Footer: React.FC = () => {
  return (
    <div className="text-sm lg:px-0 lg:px-8 text-gray-500 flex flex-col items-center text-center">
      <p className="mb-8 text-secondaryGrayscale font-normal text-[12px]">
        Cashia is licenced and regulated by the Central Bank of Kenya
      </p>

      <div className="flex  items-center gap-2 flex-wrap justify-center">
        <div className="flex items-center justify-center">
          <span className="mr-2 text-secondaryGrayscale">Powered by</span>
          <a
            href="https://cashia.com"
            target="_blank"
            rel="noopener noreferrer"
            className=" text-secondaryGrayscale text-sm font-semibold">
            <img src={Cashia} alt="Cashia" className="h-fit" />
          </a>

          <div className="w-[1px] h-8 bg-subtleGrey mx-4" />
          <img src={Pci} alt="PCI DSS" className="h-fit" />
          <div className="w-[1px] h-8 bg-subtleGrey mx-4" />
        </div>

        <div className="flex items-center gap-3 justify-center">
          <a
            href="#"
            className=" text-secondaryGrayscale text-sm font-semibold">
            Terms
          </a>
          <a href="#" className="text-secondaryGrayscale text-sm font-semibold">
            Privacy
          </a>
        </div>
      </div>
    </div>
  );
};
export default Footer;
